
import { Component, Input, OnDestroy } from '@angular/core';
import { EnvironmentActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers/index';
import { CGUConsent } from '@app/shared/models/cguConsent';
import { Store } from '@ngrx/store';
import { Observable, Subscription, first } from 'rxjs';

@Component({
    selector: 'app-cgu-cookie-container',
    templateUrl: './cgu-cookie-container.component.html',
    styleUrls: ['./cgu-cookie-container.component.scss']
})
export class CguCookieContainerComponent implements OnDestroy {
    @Input() template: 'MAIN' | 'VIEWER';

    cguConsent$: Observable<CGUConsent>;
    isCookiesConsentSetByUser$: Observable<boolean>;
    cookieDisplayed = true;
    subscriptions: Subscription[] = [];

    constructor(
        private readonly store$: Store<fromRoot.State>,
    ) {
        this.isCookiesConsentSetByUser$ = this.store$.select(fromRoot.getIsCookiesConsentSetByUser);
        this.subscriptions.push(
            this.isCookiesConsentSetByUser$.pipe(first(ok => ok)).subscribe(() => this.cookieDisplayed = false)
        );
        this.store$.dispatch(EnvironmentActions.LoadCookiesConsentConfiguration());
    }

    ngOnDestroy(): void {
        this.subscriptions.map(subscription => subscription.unsubscribe());
    }

    onManageCookies(event) {
        this.cookieDisplayed = false;
    }


}


